import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/index.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));

// StrictMode intentionally double-invokes effects in development
// which opens duplicate Firestore listeners and triggers ca9.
// Removed here — App itself is safe and well-structured.
root.render(
  <App />
);